import { ComposedLineBarChart } from '@/components/analytics/ComposedLineBarChart.tsx'
import { createComposedLineBarConfig } from '@/components/analytics/ComposedLineBarConfig.tsx'
import { formatXAxisValue } from '@/utils/chart.ts'
import { format } from 'date-fns'
import { useMemo } from 'react'

interface ProjectCardChartProps {
  iterations: ProjectCardIteration[]
}

export const ProjectCardChart = ({ iterations }: ProjectCardChartProps) => {
  const chartData = useMemo(() => {
    if (!iterations || iterations.length === 0) return []

    return iterations.map((iteration) => ({
      ...iteration,
      acceptedPoints: iteration.acceptedPoints === null ? 0 : iteration.acceptedPoints,
      teamStrength: iteration.teamStrength * 100,
    }))
  }, [iterations])

  const chartConfig = useMemo(() => {
    return createComposedLineBarConfig<ProjectCardIteration>({
      lineKey: 'teamStrength',
      barKey: 'acceptedPoints',
      hideLine: true,
      hideGrid: true,
      hideXAxis: true,
      hideYAxis: true,
      xFormatter: (cardIteration: ProjectCardIteration, index: number, all: ProjectCardIteration[]) =>
        formatXAxisValue(
          new Date(cardIteration.start),
          index,
          all.map((i) => new Date(i.start)),
        ),
      tooltipHeaderFormatter: (cardIteration) =>
        `${format(new Date(cardIteration.start), 'MMM d')} - ${format(new Date(cardIteration.finish), 'MMM d')}`,
      lineValueFormatter: (value) => `${value} %`,
      barValueFormatter: (value) => `${value} pts`,
      lineLabel: 'Team Strength',
      barLabel: 'Accepted Points',
      tooltip: { headerClassName: 'border-2 bg-white text-contents-black' },
    })
  }, [])

  return (
    <div className="h-[100px] w-full">
      <ComposedLineBarChart<ProjectCardIteration>
        data={chartData}
        config={chartConfig}
        height={100}
        showCursorLine={false}
      />
    </div>
  )
}
